import { Helmet } from 'react-helmet-async';

export const SEOHead = ({ 
  title, 
  description, 
  keywords,
  canonical,
  ogImage = "https://images.unsplash.com/photo-1762195340046-415140d8b1b2?w=1200",
  schema
}) => {
  const schemaMarkup = schema || {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Noble Detailing",
    "image": ogImage,
    "telephone": "559-880-1818",
    "url": "https://nobledetailing.com",
    "priceRange": "$$",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Fresno",
      "addressRegion": "CA",
      "addressCountry": "US"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "36.7378",
      "longitude": "-119.7871"
    },
    "areaServed": [
      { "@type": "City", "name": "Fresno" },
      { "@type": "City", "name": "Madera" },
      { "@type": "City", "name": "Clovis" },
      { "@type": "City", "name": "Chowchilla" }
    ],
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
      "opens": "07:00",
      "closes": "20:00"
    },
    "sameAs": [
      "https://instagram.com/nobledetail",
      "https://tiktok.com/@nobleDetails"
    ]
  };

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      {canonical && <link rel="canonical" href={canonical} />}
      
      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="en_US" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      
      {/* Mobile */}
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="theme-color" content="#050505" />
      
      {/* Schema.org structured data */}
      <script type="application/ld+json">
        {JSON.stringify(schemaMarkup)}
      </script>
    </Helmet>
  );
};
